export default __webpack_public_path__ + "static/media/course1_L.643c801b.gif";